import { getMyAvailabilityConstants } from 'src/redux/actions/constant';

const {
CREATE_PTO_SUCCESS_REQUEST,
CREATE_PTO_FAILURE_REQUEST,
CREATE_PTO_RESET_REQUEST
} = getMyAvailabilityConstants;

const intitialstate: object = {
  isCreated: false,
  response: null,
};

export const createPtoRequestReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case CREATE_PTO_SUCCESS_REQUEST: {
      return {
        ...state,
        isCreated: true,
        response: action.payload,
      };
    }

    case CREATE_PTO_FAILURE_REQUEST:
      return {
        ...state,
        isCreated: false,
        response: action.payload,
      };

    case CREATE_PTO_RESET_REQUEST:
      return intitialstate;

    default:
      return state;
  }
};
